import {HStack, Input, Spinner, Table, TableContainer, Tbody, Text, Textarea, useToast, VStack} from "@chakra-ui/react";
import * as React from "react";
import {useEffect, useRef, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {CheckCircleIcon} from "@chakra-ui/icons";
import {scrollbarCss} from "../../../../theme/theme";
import {Resolver, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {CategoryModelNew, CategoryQueryParamsNew} from "../../../../data/model/Category";
import {categorySchema, categorySchemaEdit} from "../../../../data/schema/category";
import {
    addCategoryNew,
    addMediaPhp,
    deleteMediaNew,
    editCategoryNew,
    getCategoriesByIdNew
} from "../../../../data/api/Customer";
import {BackButtonComponent} from "../../../../components/molecules/BackButton/BackButtonComponent";
import {useQuery} from "@tanstack/react-query";
import {BaseResponse} from "../../../../data/model/BaseResponse";
import {AddTableRow} from "../../../../components/atoms/AddTableRow/AddTableRow";
import {ImageSelectorComponent} from "../../../../components/molecules/ImageSelectorComponent/ImageSelectorComponent";
import {SetImageModel} from "../../../../data/model/Producer";

export const AddCategoryPage = () => {
    const navigate = useNavigate();
    const fileInputRef: React.RefObject<HTMLInputElement> = useRef(null);

    const {id} = useParams();

    const categoryResponse = useQuery({
        queryKey: ["get-category", id],
        enabled: !!id,
        queryFn: () => getCategoriesByIdNew(id),
        refetchOnWindowFocus: "always",
        staleTime: 0
    });

    const {data, refetch} = categoryResponse || {};
    const categoryData = data?.data as BaseResponse<CategoryModelNew> || {};
    const {name: nameOld, description: descriptionOld, image: imageOld} = categoryData.data || {};

    const methods = useForm<CategoryQueryParamsNew>({
        mode: "all",
        resolver: yupResolver(id ? categorySchemaEdit : categorySchema) as Resolver<CategoryQueryParamsNew>
    });

    // const [selectedImageFile, setSelectedImageFile] = useState<File | null>(null);
    // const [imageUrl, setImageUrl] = useState<string | null>();
    // const [deleteImage, setDeleteImage] = useState(false);

    const [mainImage, setMainImage] = useState<SetImageModel | undefined>();
    const [imageToDelete, setImageToDelete] = useState<string[]>([]);

    const toast = useToast();

    const {
        register,
        handleSubmit,
        formState: {
            errors,
            isSubmitting,
        }
    } = methods;

    useEffect(() => {
        if (imageOld?.url) {
            setMainImage({
                imageUrl: imageOld?.url,
                mediaType: imageOld.mediaType,
                id: imageOld.id,
                name: imageOld.name
            });
        }
    }, [imageOld?.url]);

    const onSubmit = async (category: CategoryQueryParamsNew) => {
        const list: SetImageModel[] = [];
        mainImage?.file && list.push(mainImage);

        if (id) {
            // const imageBase64 = !selectedImageFile ? undefined : await toBase64(selectedImageFile).then(base64String => base64String as string);
            const model: CategoryQueryParamsNew = {
                name: (category.name === nameOld || category.name === "") ? undefined : category.name,
                description: (category.description === descriptionOld || category.description === "") ? undefined : category.description,
                // media: `true&${imageBase64}`
            }

            // deleteImage && await deleteMediaNew(imageOld?.id ?? '');

            await Promise.all([
                ...imageToDelete.map(value => value !== "" && deleteMediaNew(value)),
            ]);

            if (list[0]?.file) {
                await addMediaPhp(list[0].file).then(async value => {
                    await editCategoryNew(id, {
                        ...model,
                        image: value
                    }).then(() => {
                        refetch().then(() => navigate(-1));
                    }).catch(reason => {
                        toast({
                            title: "Si è verificato un errore",
                            description: reason?.message ?? "-"
                        });
                    })
                });
            } else {
                await editCategoryNew(id, {
                    ...model
                }).then(() => {
                    refetch().then(() => navigate(-1));
                }).catch(reason => {
                    toast({
                        title: "Si è verificato un errore",
                        description: reason?.message ?? "-"
                    });
                });
            }
        } else {
            if (list[0]?.file) {
                await addMediaPhp(list[0].file).then(async value => {
                    const model: CategoryQueryParamsNew = {
                        name: (category.name === nameOld || category.name === "") ? undefined : category.name,
                        description: (category.description === descriptionOld || category.description === "") ? undefined : category.description,
                        image: value
                    }

                    await addCategoryNew(model).then(_ => {
                        navigate("/products/category", {replace: true});
                    }).catch(reason => {
                        toast({
                            title: "Si è verificato un errore",
                            description: reason?.message ?? "-"
                        });
                    });
                })
            } else {
                const model: CategoryQueryParamsNew = {
                    name: (category.name === nameOld || category.name === "") ? undefined : category.name,
                    description: (category.description === descriptionOld || category.description === "") ? undefined : category.description,
                }

                await addCategoryNew(model).then(_ => {
                    navigate("/products/category", {replace: true});
                }).catch(reason => {
                    toast({
                        title: "Si è verificato un errore",
                        description: reason?.message ?? "-"
                    });
                });
            }
        }
    }

    // const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    //     if (event.target.files && event.target.files.length > 0) {
    //         const file = event.target.files[0];
    //         setSelectedImageFile(file);
    //         setImageUrl(URL.createObjectURL(event.target.files[0]));
    //     }
    // };

    // const handleButtonClick = () => {
    //     fileInputRef?.current?.click();
    // }

    function getNameRow() {
        return <AddTableRow name={"Nome"}>
            <VStack alignItems={"flex-start"} w={"100%"}>
                <Input
                    id={"product-name"}
                    inputMode={"text"}
                    colorScheme={"primary"}
                    variant='filled'
                    _placeholder={{fontSize: 14}}
                    errorBorderColor={"error.700"}
                    defaultValue={nameOld}
                    disabled={isSubmitting}
                    isInvalid={!!errors.name}
                    focusBorderColor={!!errors.name ? "error.700" : "primary.400"}
                    {...register('name')}
                    placeholder='Es. La mia categoria'/>
                {!!errors.name && <Text fontSize={14}
                                        alignSelf={"start"}
                                        textColor={"error.700"}>
                    {errors.name && errors.name.message}
                </Text>}
                <Text fontSize={"14px"} color={"rgba(0,0,0,0.6)"}>Il nome come appare sul sito.</Text>
            </VStack>
        </AddTableRow>;
    }

    function getDescriptionRow() {
        return <AddTableRow name={"Descrizione"}>
            <VStack>
                <Textarea
                    id={"description"}
                    colorScheme={"primary"}
                    variant='filled'
                    noOfLines={8}
                    defaultValue={descriptionOld}
                    _placeholder={{
                        fontSize: 14
                    }}
                    disabled={isSubmitting}
                    isInvalid={!!errors.description}
                    focusBorderColor={!!errors.description ? "error.700" : "primary.400"}
                    {...register('description')}
                    placeholder='Inserisci una presentazione o descrizione della categoria.'/>
                {!!errors.description && <Text fontSize={14}
                                               alignSelf={"start"}
                                               mt={"8px"}
                                               textColor={"error.700"}>
                    {errors.description && errors.description.message}
                </Text>}
                <Text fontSize={"14px"} color={"rgba(0,0,0,0.6)"}>Inserisci una descrizione della
                    nuova categoria, ad esempio la tipologia di prodotti
                    verranno inseriti all'interno o le caratteristiche che le accomuna.</Text>
            </VStack>
        </AddTableRow>;
    }

    function getImageRow() {
        return <AddTableRow name={"Immagine"}>
            <ImageSelectorComponent
                setImageModel={setMainImage}
                imageModel={mainImage}
                isMain={true}
                handleCloseButtonClick={(model) => {
                    if (id) setImageToDelete([...(imageToDelete || []), model?.id || ""]);
                    setMainImage(undefined);
                }}
                description={"Seleziona l'immagine rappresentativa della categoria"}/>
        </AddTableRow>;
    }

    // function getImageRow() {
    //     return <AddTableRow name={"Immagine"}>
    //         <VStack w={"100%"}>
    //             <Input
    //                 type="file"
    //                 id="image"
    //                 name={"image"}
    //                 accept="image/*"
    //                 ref={fileInputRef}
    //                 onChange={handleFileChange}
    //                 style={{display: 'none'}}
    //             />
    //
    //             {!imageUrl && <Button
    //                 colorScheme="teal"
    //                 mt={"8px"}
    //                 w={"100%"}
    //                 h={"64px"}
    //                 leftIcon={<ImageIcon w={"32px"} h={"32px"}/>}
    //                 onClick={handleButtonClick}>Scegli un'immagine</Button>}
    //         </VStack>
    //
    //         {imageUrl && <Stack borderRadius={"16px"} minH={"86px"} overflow={"hidden"}
    //                             position={"relative"} maxW={"300px"}>
    //             <CloseIcon cursor={"pointer"} right={"8px"} top={"8px"} position={"absolute"}
    //                        borderRadius={"50%"} color={"white"} p={"8px"}
    //                        w={"32px"}
    //                        h={"32px"}
    //                        backgroundColor={"error.700"} onClick={() => {
    //                 setDeleteImage(true);
    //                 setSelectedImageFile(null);
    //                 setImageUrl(null);
    //             }}/>
    //             <Image src={imageUrl} alt="Uploaded Image"/>
    //         </Stack>}
    //     </AddTableRow>;
    // }

    return <VStack w={"100%"} h={"100%"} alignItems={"center"}>
        <HStack cursor={"pointer"} h={"64px"} px={"24px"} borderRadius={"24px"} position={"absolute"}
                alignItems={"center"} zIndex={5}
                justifyContent={"center"} bottom={"24px"} right={"48px"}
                backgroundColor={isSubmitting ? "primary.100" : "secondary.200"}
                _hover={{backgroundColor: "tertiary.200"}} onClick={handleSubmit(onSubmit)}>
            {isSubmitting ? <Spinner width={"24px"} height={"24px"}/> :
                <CheckCircleIcon w={"24px"} h={"24px"} color={"primary.400"} alignSelf={"center"}/>}
            <Text fontWeight={"bold"} color={"primary.400"}>Conferma</Text>
        </HStack>
        <BackButtonComponent/>
        <VStack justifyContent={"center"} flex={1} alignItems={"center"} overflowY={"hidden"}>
            <Text fontSize={"24px"} justifySelf={"center"} fontWeight={"bold"} ms={"24px"}>Nuova categoria</Text>
            <TableContainer alignItems={"center"} whiteSpace={"pre-line"} mr={"16px"} overflowY={"scroll"}
                            css={scrollbarCss({marginRight: 48})}>
                <Table variant={"none"} w={"70%"} mx={"auto"}>
                    <Tbody>
                        {getNameRow()}
                        {getDescriptionRow()}
                        {getImageRow()}
                    </Tbody>
                </Table>
            </TableContainer>
        </VStack>
    </VStack>
}
